import { useState, useEffect } from 'react';
import { CustomPaymentTypesApi } from '@/api/clients/custom-payments/custom-payment-types.api';

export const useGetCustomPaymentTypesForForm = (
  isCustomPaymentTypesEnabled = true,
  refundId = null,
) => {
  const [customPaymentTypes, setCustomPaymentTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCustomPaymentTypes = async () => {
      if (!isCustomPaymentTypesEnabled) {
        setCustomPaymentTypes([]);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const data = (await CustomPaymentTypesApi.getCustomPaymentTypesForm())
          .data;

        const types = !refundId
          ? data.filter((type) => type.showInCreatePayment)
          : data;

        setCustomPaymentTypes(types);
      } catch (err) {
        const errorMessage =
          err.response?.data?.message || 'Failed to fetch custom payment types';
        setError(errorMessage);
        console.error('Error fetching custom payment types:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomPaymentTypes();
  }, [isCustomPaymentTypesEnabled, refundId]);

  return {
    customPaymentTypes,
    loading,
    error,
  };
};
